import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const MemberContext = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null);
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(() => {
    return api
      .get("/member/me")
      .then(({ data }) => setMember(data.member))
      .catch(() => setMember(null))
      .finally(() => setChecking(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/member/logout"); } catch (e) { /* ignore */ }
    setMember(null);
  };

  return (
    <MemberContext.Provider value={{ member, checking, refresh, logout }}>
      {children}
    </MemberContext.Provider>
  );
}

export function useMember() {
  return useContext(MemberContext);
}
